export const Pay_Manual_Only = 83;
export const Pay_Rights = 61;
export const View_Pay = 84;
export const Remit_Rights = 33;
export const AgentNet_Admin = 36;
export const FRAUD_VALIDATION = 141;
export const FRAUD_VALIDATION_READ_ONLY = 142;
export const WIRE_VALIDATION = 144;
export const VIEW_AGENT_DASHBOARD_PREMIUM_REVENUE = 46;
export const CAN_MANAGE_ESIGNATURES = 106;
export const ASC_STAFF = 66;
export const INVOICE_DASHBOARD = 145;
/** Allows adding, voiding and unvoiding policy inventory as well as searching it */
export const INVENTORY_MANAGEMENT = 143;
/** Allows searching policy inventory only — no add, no void, no unvoid, no Form Management */
export const VIEW_INVENTORY_MANAGEMENT = 146;

/** Display names from Firm API `manageUsers/rights` AdditionalRights — must match DB/catalog */
export const ACTIVITY_RIGHT_LABEL_VIEW_AGENT_DASHBOARD_PREMIUM_REVENUE = 'View Agent Dashboard Premium Revenue';
export const ACTIVITY_RIGHT_LABEL_FRAUD_VALIDATION = 'Fraud Validation';
export const ACTIVITY_RIGHT_LABEL_WIRE_VALIDATION = 'Wire Validation';

/**
 * Agent role names that should default to having Fraud (141) & Wire (144) validation
 * when present in Additional Rights (ANS-7533).
 * These roles automatically get these rights checked when creating/editing users.
 */
export const ROLES_WITH_DEFAULT_FRAUD_WIRE_VALIDATION = new Set([
  'Agent',
  'Title & Escrow User',
  'Title Only User',
  'Escrow Only User',
  'Approved Attorney',
]);
